////import React, { createContext, useContext, useState } from 'react';

////const UserContext = createContext();

////export function useUser() {

////    return useContext(UserContext);

////}

////export function UserProvider({ children }) {

////    const [user, setUser] = useState(null);

////    const loginUser = (userData) => {

////        setUser(userData);

////    };

////    const logoutUser = () => {

////        setUser(null);

////    };

////    return (
////        <UserContext.Provider value={{ user, loginUser, logoutUser }}>

////            {children}
////        </UserContext.Provider>

////    );

////}


// UserContext.js
import React, { createContext, useContext, useState } from "react";

// 1️⃣ Create the context
const UserContext = createContext();

// Session persistence key — keeps the user logged in across page reloads /
// full navigations within the same tab. Cleared on logout or tab close.
const STORAGE_KEY = "vms_user";

const readStoredUser = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

// 2️⃣ Custom hook to use the context
export function useUser() {
    return useContext(UserContext);
}

// 3️⃣ Provider component
export function UserProvider({ children }) {
    // Hydrate from sessionStorage so a refresh / hard navigation doesn't log out
    const [user, setUser] = useState(readStoredUser);

    // Login function — persist the session
    const loginUser = (userData) => {
        setUser(userData);
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
        } catch {
            /* storage unavailable — keep in-memory state only */
        }
    };

    // Logout function — clear the persisted session
    const logoutUser = () => {
        setUser(null);
        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch {
            /* ignore */
        }
    };

    // Provide state and functions to children
    return (
        <UserContext.Provider value={{ user, loginUser, logoutUser }}>
            {children}
        </UserContext.Provider>
    );
}